<template>
  <div class="menu">
    <img src="../assets/menu_titulo.png" class="titulo">
    <div class="items" v-for="(iten, index) in itens" :key="index" :class="{'active': currentRooute == iten.link}" @click="changeRoute(iten.link)"> 
      <p class="text-uppercase">{{iten.name}}</p>
    </div>
    <a class="items" target="_blank" href="http://adesao.stillos.com.br/passo1.asp?chave={12312312S09801928DQLLQW2102019113419}&a=puyfjIjgPbIjgPboirqi">
      <p class="text-uppercase">
        <span class="assento" style="top: -50%; right: 5%;">˜</span>
        Adesao
      </p>
    </a>
    <a class="items" target="_blank" href="http://comissao.stillos.com.br">
      <p class="text-uppercase">
        <span class="assento" style="top: -50%; right: 5%;">˜</span>
        Comissao
      </p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  computed: {
    currentRooute(){
      return this.$route.name
    }
  },
  methods: {
    changeRoute(name){
      this.$router.push({name})
    }
  },
  data: () => ({
    itens: [
      {
        name: 'home',
        link: 'home'
      },
      {
        name: 'galeria',
        link: 'galeria'
      },
      {
        name: 'loja',
        link: 'loja'
      },
      {
        name: 'formandos',
        link: 'formandos'
      },
      // {
      //   name: 'comissão',
      //   link: 'comissao'
      // }
    ]
  }),
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: 'cc_zoinksmedium';
  src: url('../assets/cc-zoinks-medium-webfont.woff2') format('woff2'),
        url('../assets/cc-zoinks-medium-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

.menu{
  height: 1080px;
  width: 650px;
  background-image: url('../assets/menu_fundo.png');
  background-size: cover;
  position: fixed;
  right: 0px;
  top: 0px;
  z-index: 1;
  .titulo{
    position: relative;
    float: left;
    margin-top: 20px;
    margin-left: 150px;
    width: 200px;
  }
  .items {
    position: relative;
    float: left;
    width: 475px;
    height: 150px;
    background-image: url('../assets/menu_item.png');
    background-size: contain;
    transition: 200ms;
    background-position: center center;
    margin-left: 130px;
    text-align: right;
    padding-top: 60px;
    padding-right: 40px;
    color: #cad8ff;
    font-family: 'cc_zoinksmedium';
    font-size: 42px;
    cursor: pointer;
    margin-top: -10px;
    text-decoration: none;
    &:hover, &.active {
      width: 580px;
      height: 190px;
      margin-left: 5px;
      background-image: url('../assets/menu_item_hover.png');
      color: #002e9e;
      padding-top: 80px;
      padding-right: 70px;
      font-size: 48px;
    }
    p{
      transform: rotate(-10deg);
    }
    .assento {
      position: absolute;
      font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
      font-size: 72px;
    }
  }
}

</style>
